/**
 * clipText.js — clip a label to a fixed display width for table cells.
 *
 * The limit INCLUDES the trailing "..." — a clipped result is never longer
 * than `max`. Text at or under `max` is returned whole (whitespace collapsed).
 * Over it, the text is cut back to the last whole word inside `max - 3`, any
 * dangling separator (" —", " /", "(", ",") is dropped, then "..." appended.
 * A single word longer than the budget is hard-cut. The cell shows the full
 * text on hover, so the clip only has to be enough to recognise the value.
 */
const ELLIPSIS = '...';
const TRAILING_SEP = /[\s\-–—/(,;:&+]+$/;

export function clipText(text, max = 30) {
  const s = String(text ?? '').replace(/\s+/g, ' ').trim();
  if (s.length <= max) return s;
  const budget = Math.max(1, max - ELLIPSIS.length);
  let cut = s.slice(0, budget);
  if (s[budget] !== ' ') {                       // mid-word → back up to the last space
    const sp = cut.lastIndexOf(' ');
    if (sp > 0) cut = cut.slice(0, sp);
  }
  cut = cut.replace(TRAILING_SEP, '');
  if (!cut) cut = s.slice(0, budget);
  return cut + ELLIPSIS;
}
